import { motion } from "framer-motion";
import { faNum } from "@/lib/format";

export const ParsianBoard = ({ items }) => (
  <section id="parsian" data-testid="parsian-board" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-20 sm:px-6 lg:px-12">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="mb-10 flex flex-wrap items-center justify-between gap-3"
    >
      <div>
        <span className="text-xs tracking-widest text-amber-500/70">سکه‌های پارسیان</span>
        <h2 className="mt-2 text-base font-bold text-amber-100 md:text-lg">نرخ فروش سکه‌های پارسیان</h2>
      </div>
    </motion.div>
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {items?.length ? (
        items.map((p, i) => (
          <motion.div
            key={p.id}
            data-testid={`parsian-item-${p.id}`}
            initial={{ opacity: 0, y: 26, rotateX: -12 }}
            whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 5) * 0.06 }}
            whileHover={{ y: -6 }}
            className="gold-sheen glass rounded-2xl p-4 text-center transition-colors duration-300 hover:border-amber-500/45"
            style={{ transformStyle: "preserve-3d" }}
          >
            <div className="text-base font-bold text-amber-200">{p.name}</div>
            <div className="mt-1 text-[10px] text-stone-500">{p.sub}</div>
            <div data-testid={`parsian-sell-${p.id}`} className="mt-3 text-sm font-bold text-stone-100">
              {faNum(p.sell)}
              <small className="mr-1 text-[10px] font-normal text-stone-500">تومان</small>
            </div>
          </motion.div>
        ))
      ) : (
        Array.from({ length: 18 }).map((_, i) => <div key={i} className="glass h-28 animate-pulse rounded-2xl" />)
      )}
    </div>
  </section>
);
